import { Pipe } from "@angular/core";

///<summary>
/// NANPFormattedPhone: North American Numbering Plan Formatted Phone
///</summary>
@Pipe({
  name: "NANPFormattedPhone"
})
export class PhonePipe {
  transform(inputVal: string | undefined): string {
    if (!inputVal) {
      return '';
    }

    inputVal = inputVal;

    const areaCodeStr = inputVal.slice(0, 3);
    const midSectionStr = inputVal.slice(3, 6);
    const lastSectionStr = inputVal.slice(6, 10);

    return `(${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;
  }
}

@Pipe({
  name: "CountryCode"
})
export class CountryCodePipe {
  transform(inputVal: string | undefined): string {
    if (!inputVal) {
      return '';
    }

    return inputVal.startsWith('+') ? inputVal : `+${inputVal}`;
  }
}

@Pipe({
  name: "PhoneExtension"
})
export class PhoneExtensionPipe {
  transform(inputVal: string | undefined): string {
    if (!inputVal) {
      return '';
    }

    return `Ext. ${inputVal}`;
  }
}